import { useEffect, useState } from 'react'

import _ from 'lodash'
import axios from '../../axios/axios'
import { notifyError } from '../../util/notifyUtil'

const useMessages = (forceRefresh) => {
  const [data, setData] = useState()
  const [loading, setLoading] = useState()
  const [error, setError] = useState()

  useEffect(() => {
    ;(async () => {
      try {
        setLoading(true)
        const result = await axios.get('/admin/message')
        setData(_.reverse(_.sortBy(result.data.data, 'expires')))
      } catch (e) {
        setError(e)
        notifyError('error', e)
      } finally {
        setLoading(false)
      }
    })()
  }, [forceRefresh])

  return { messages: data, loading, error }
}

export default useMessages
